import { render } from "./FlowStep.vue?vue&type=template&id=20edf3be"
import script from "./FlowStep.vue?vue&type=script&lang=js"
export * from "./FlowStep.vue?vue&type=script&lang=js"
script.render = render

export default script